import { render, staticRenderFns } from "./Fjtest.vue?vue&type=template&id=3dbb5078&scoped=true&"
import script from "./Fjtest.vue?vue&type=script&lang=js&"
export * from "./Fjtest.vue?vue&type=script&lang=js&"
import style0 from "./Fjtest.vue?vue&type=style&index=0&id=3dbb5078&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbb5078",
  null
  
)

export default component.exports